export default {"src":"/_next/static/media/youtube.8d874ae1.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};